import { Controller } from "@hotwired/stimulus";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default class extends Controller {
  connect() {
    this.swiper = new Swiper(this.element.querySelector(".mySwiper"), {
      modules: [Navigation, Pagination],
      slidesPerView: 2,
      spaceBetween: 30,
      loop: true,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        375: { slidesPerView: 1, spaceBetween: 20 },
        768: { slidesPerView: 1.4, spaceBetween: 20 },
        991: { slidesPerView: 1.6, spaceBetween: 30 },
        1199: { slidesPerView: 2, spaceBetween: 30 },
      },
    });
  }

  disconnect() {
    this.swiper.destroy();
  }
}
